var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "performance-marketing-section",
    { attrs: { title: "Questions & Answers" } },
    [
      _c(
        "div",
        { staticClass: "_flexcol _gap-2" },
        _vm._l(_vm.questions, function (question) {
          return _c("faq-box", {
            key: question.title,
            attrs: {
              nested: "",
              title: question.title,
              description: question.description,
              "is-initially-collapsed": "",
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }